import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import styles from './Page.module.css';
import ModalExportarLista from '../components/common/ModalExportarLista';

const COLUNAS_EXPORT = [
  { key: 'codigo',     label: 'Código' },
  { key: 'nome',       label: 'Nome' },
  { key: 'cpf_cnpj',   label: 'CPF/CNPJ' },
  { key: 'tipo_pessoa', label: 'Tipo Pessoa', padrao: false,
    render: c => c.tipo_pessoa === 'J' ? 'Jurídica' : 'Física' },
  { key: 'email',      label: 'E-mail' },
  { key: 'fone1',      label: 'Telefone' },
  { key: 'cidade',     label: 'Cidade' },
  { key: 'estado',     label: 'UF' },
];

// Lista de consulta — o cadastro de clientes é feito em Cad. Clientes
// (tela completa) ou pelo cadastro rápido do PDV (F10 → + Novo Cliente).
export default function Clientes() {
  const [busca, setBusca] = useState('');
  const [modalExportar, setModalExportar] = useState(false);

  const { data: clientes = [], isLoading } = useQuery({
    queryKey: ['clientes', busca],
    queryFn: () => api.get('/clientes', { params: { busca } }).then((r) => r.data),
  });

  // A lista na tela é paginada (limite padrão do backend) — pra exportar
  // "tudo" que bate com o filtro, busca à parte com todos=true só quando o
  // modal abre.
  const { data: clientesExport = [] } = useQuery({
    queryKey: ['clientes-export', busca],
    queryFn: () => api.get('/clientes', { params: { busca, todos: 'true' } }).then((r) => r.data),
    enabled: modalExportar,
  });

  return (
    <div>
      <div className={styles.topbar}>
        <h2 className={styles.titulo}>Clientes</h2>
        <div className={styles.acoes}>
          <input className={styles.busca} placeholder="Buscar cliente..." value={busca} onChange={(e) => setBusca(e.target.value)} />
          <button className={styles.btnSecundario} onClick={() => setModalExportar(true)} disabled={!clientes.length}>
            📤 Exportar
          </button>
        </div>
      </div>

      {isLoading ? <p>Carregando...</p> : (
        <div className={styles.tabela}>
          <table>
            <thead>
              <tr><th>Nome</th><th>E-mail</th><th>Telefone</th><th>CPF/CNPJ</th></tr>
            </thead>
            <tbody>
              {clientes.map((c) => (
                <tr key={c.id}>
                  <td><strong>{c.nome}</strong></td>
                  <td>{c.email || '—'}</td>
                  <td>{c.fone1 || '—'}</td>
                  <td>{c.cpf_cnpj || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modalExportar && (
        <ModalExportarLista
          titulo="Clientes"
          colunas={COLUNAS_EXPORT}
          dados={clientesExport}
          nomeArquivo={`clientes_${new Date().toISOString().slice(0, 10)}`}
          onClose={() => setModalExportar(false)}
        />
      )}
    </div>
  );
}
